import clsx from "clsx";
import type { ReactNode } from "react";

/** Подпись мелким шрифтом: пояснение, счётчик, название группы. */
export function Hint({ children, className }: { children: ReactNode; className?: string | undefined }) {
  return <div className={clsx("text-[11.5px] text-fg-faint", className)}>{children}</div>;
}
